import { render, staticRenderFns } from "./detail-table.vue?vue&type=template&id=f571709c&scoped=true"
import script from "./detail-table.vue?vue&type=script&lang=js"
export * from "./detail-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f571709c",
  null
  
)

export default component.exports